<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		persistent
		:max-width="maxWidth"
	>
		<template v-slot:activator="{ on: dialog, attrs }">
			<slot name="activator" :attrs="attrs" :dialog="dialog">
				<v-tooltip bottom>
					<v-btn icon v-bind="attrs" v-on="{ ...dialog }">
						<v-icon>mdi-pencil</v-icon>
					</v-btn>
					<span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span>
				</v-tooltip>
			</slot>
		</template>

			<!-- <v-tooltip bottom> -->
				<!-- <template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</slot>
				</template> -->
				<!-- <span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span> -->
			<!-- </v-tooltip> -->

		<v-card>
			<v-toolbar flat dark color="primary">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<!-- <v-btn icon @click="onSave" >
					<v-icon>mdi-content-save</v-icon>
				</v-btn> -->

				<!-- <v-divider vertical></v-divider> -->

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<v-form ref="form">
					<v-row>
						<v-col cols="12" md="2">

						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-snackbar v-model="snackbar.visible" :timeout="snackbar.timeout" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:actions>
				<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
			</template>
		</v-snackbar>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
/* import zDetailVehicle from '@/views/dialogs/details/VehicleRequest'
import zDialogEstimate from '@/views/dialogs/VehicleParkEstimate'
import zDialogDetailEstimate from '@/views/dialogs/details/VehicleParkEstimate'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete2'
import zImportExcel from '@/views/components/dialogs/Import'
import zPdfEstimate from '@/views/pdf/VehicleParkEstimate' */

//import * as XLSX from 'xlsx'; //https://www.npmjs.com/package/xlsx

export default {
	name: 'DialogDetailVehiclePartDamage',
	mixins: [mixin],
	//components: { zDetailVehicle, zDialogEstimate, zDialogDetailEstimate, zConfirmDelete, zImportExcel, zPdfEstimate },
	data: () => ({
		select: {
			vehicles: [],
			estimates: [],
		},

		itemPdf: {},

		snackbar: {
			visible: false,
			text: null,
			timeout: 2000,
			color: "success"
		},
		/* loadings: {
			category: false,
			brand: false,
			model: false,
			year: false,
			type: false,
		}, */
	}),

	props: {
		title: 				{ type: String, default: 'Парк' },
		icon: 				{ type: String, default: 'mdi-car-seat' },
		maxWidth: 			{ type: Number, default: 800 },

		/* category: 			{ type: Object, default: null },
		brand: 				{ type: Object, default: null },
		model: 				{ type: Object, default: null },
		modelYear: 			{ type: Number, default: null },
		type: 				{ type: Object, default: null }, */
	},

	computed: {
		//...mapGetters('VehiclePark', [ 'item' ]),
		/* ...mapGetters('VehicleCategory', { categories: 'items' }),
		...mapGetters('VehicleBrand', { brands: 'items' }),
		...mapGetters('VehicleBrandModel', { models: 'items' }),
		...mapGetters('VehicleBrandModelYear', { years: 'items' }),
		...mapGetters('VehicleInsuranceType', { insuranceTypes: 'items' }), */

		id() {
			return this.item?.id ? this.item.id : null
		},
	},

	created () {
		//console.log(this.$options.name, 'created')

		//this.fullscreen = true;

		//this.focusCategory()?.then(() => this.$set(this.item, 'category', this.categories[0]))
		//this.focusType()?.then(() => this.$set(this.item, 'type', this.types[0]))
	},

	methods: {
		//...mapActions('VehiclePark', [ 'find', 'create', 'update', 'setItem' ]),

		onOpen () {
			//console.log(this.$options.name, 'onOpen', 'selected', this.selected)
			this.setItem();
			if(this.selected?.id) {
				this.loading = true
				this.find(this.selected.id).finally(() => (this.loading = false));
			}
		},

		onOK() {
			//console.log(this.$options.name, 'item', this.item)
			if(this.$refs.form.validate()) {
				this.loading = true
				//let p = this.id ? this.update(this.selected) : this.create();
				const p = this.save()
				p.then(()=>{
					this.dialog = false
				}).finally(() => {
					this.loading = false
				});
			}
		},
	},
}
</script>